// Query string for the live-sync WebSocket (F6, F10).
// A signed-in user may also carry a share token so a require-sign-in link still connects.
// Anonymous visitors connect with the share token and guest identity only.

export function buildLiveSyncQuery(input: {
  kind: "list" | "template" | "checklist";
  resourceId: string;
  accessToken: string | null;
  shareToken: string | null;
  guest: { guestId: string; displayName: string | null };
}): string | null {
  if (input.accessToken) {
    const params = new URLSearchParams({
      resourceKind: input.kind,
      resourceId: input.resourceId,
      token: input.accessToken,
    });
    if (input.shareToken) params.set("shareToken", input.shareToken);
    return params.toString();
  }

  if (input.shareToken) {
    const params = new URLSearchParams({
      shareToken: input.shareToken,
      guestId: input.guest.guestId,
    });
    if (input.guest.displayName) params.set("screenName", input.guest.displayName);
    return params.toString();
  }

  return null;
}
